import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "modal-dialog modal-xl modal-fullscreen-lg-down modal-dialog-centered" }
const _hoisted_2 = {
  key: 0,
  class: "modal-content border-0"
}
const _hoisted_3 = { class: "modal-header border-0" }
const _hoisted_4 = { class: "text-white-50" }
const _hoisted_5 = {
  key: 0,
  class: "photo-title-badge ms-2"
}
const _hoisted_6 = { class: "modal-body pt-0" }
const _hoisted_7 = { class: "photo-lightbox-stage" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = {
  key: 0,
  class: "photo-tile-busy"
}
const _hoisted_10 = {
  key: 0,
  class: "modal-footer border-0 justify-content-start"
}
const _hoisted_11 = {
  key: 1,
  class: "ms-auto d-flex gap-2"
}
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade photo-lightbox",
    tabindex: "-1",
    "aria-label": "Zvětšený obrázek",
    ref: "modal",
    onKeydown: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onKeydown && _ctx.onKeydown(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.current !== null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.index + 1) + " z " + _toDisplayString(_ctx.items.length), 1),
              (_ctx.titleBadge && _ctx.index === 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, [...(_cache[8] || (_cache[8] = [
                    _createElementVNode("span", { class: "fas fa-star" }, null, -1),
                    _createTextVNode("Titulní fotka ", -1)
                  ]))]))
                : _createCommentVNode("", true),
              _cache[9] || (_cache[9] = _createElementVNode("button", {
                type: "button",
                class: "btn-close btn-close-white ms-auto",
                "data-bs-dismiss": "modal",
                "aria-label": "Zavřít"
              }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("img", {
                  src: _ctx.current.url,
                  alt: _ctx.current.description
                }, null, 8, _hoisted_8),
                (_ctx.rotating)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[10] || (_cache[10] = [
                      _createElementVNode("span", {
                        class: "spinner-border text-light",
                        role: "status"
                      }, null, -1)
                    ]))]))
                  : _createCommentVNode("", true),
                (_ctx.items.length > 1)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-light photo-lightbox-previous",
                        title: "Předchozí (šipka vlevo)",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.step(-1)))
                      }, [...(_cache[11] || (_cache[11] = [
                        _createElementVNode("span", { class: "fas fa-chevron-left" }, null, -1)
                      ]))]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-light photo-lightbox-next",
                        title: "Další (šipka vpravo)",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.step(1)))
                      }, [...(_cache[12] || (_cache[12] = [
                        _createElementVNode("span", { class: "fas fa-chevron-right" }, null, -1)
                      ]))])
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.canDescribe || _ctx.canRotate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  (_ctx.canDescribe)
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        type: "text",
                        class: "form-control form-control-sm bg-dark text-white border-secondary w-auto flex-grow-1",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.description) = $event)),
                        placeholder: "Přidat popisek…",
                        "aria-label": "Popisek fotografie",
                        onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('describe', _ctx.current.id, _ctx.description.trim()))),
                        onKeydown: _cache[4] || (_cache[4] = _withKeys(($event: any) => (($event.target as HTMLInputElement).blur()), ["enter"]))
                      }, null, 544)), [
                        [_vModelText, _ctx.description]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.canRotate)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-sm btn-outline-light",
                          disabled: _ctx.rotating,
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('rotate', _ctx.current.id, 90)))
                        }, [...(_cache[13] || (_cache[13] = [
                          _createElementVNode("span", { class: "fas fa-undo me-1" }, null, -1),
                          _createTextVNode(" Otočit doleva ", -1)
                        ]))], 8, _hoisted_12),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-sm btn-outline-light",
                          disabled: _ctx.rotating,
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('rotate', _ctx.current.id, -90)))
                        }, [...(_cache[14] || (_cache[14] = [
                          _createElementVNode("span", { class: "fas fa-redo me-1" }, null, -1),
                          _createTextVNode(" Otočit doprava ", -1)
                        ]))], 8, _hoisted_13)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 544))
}